import { createStyles, makeStyles } from '@mui/styles';

export default makeStyles(() =>
  createStyles({
    root: {
      width: '100%',
    },
  }),
);
